import { AuthViewModel } from "../viewmodels/AuthViewModel.js";
import { useSingleton } from "mvc-kit/react";
// src/modules/AuthWrapper2/hooks/useAuthActions.ts
function useAuthActions() {
	const authVM = useSingleton(AuthViewModel);
	return {
		changeUser: authVM.changeUser,
		logout: authVM.logout
	};
}
export { useAuthActions };

//# sourceMappingURL=useAuthActions.js.map